export default {
  header: {
    sigla: 'SAJ-MP DOE',
    titulo: 'SAJ-MP Gestor de Publicação do Diário Oficial',
  },
  historico: {
    header: {
      dataEnvio: 'Data de envio',
      dataPublicacao: 'Data de publicação',
      ordenarPorDataEnvio: 'Ordenar por data de envio',
      ordenarPorDataDePublicacao: 'Ordenar por data de publicação',
      numeroMpDocumento: 'N° MP/Documento',
      status: 'Status',
      usuario: 'Usuário',
    },
    card: {
      enviadoEm: 'Enviado em',
      publicadoEm: 'Publicado em',
    },
  },
};
